<mat-form-field class="example-full-width">
  <mat-label [style.color]="warnLabel ? 'orange' : ''">{{ label }}</mat-label>
  <textarea [formControl]="timePickerControl" class="dontDisplay" matInput [(value)]="selectedTimeString"></textarea>
  <app-timepicker [(selectedTime)]="selectedTimeString"></app-timepicker>
</mat-form-field>
